import { BASE_NEW_API_URL } from '@/constants';
import axios from 'axios';

/**
 * Dedicated client for /token/refresh, /token/revoke and /token/oauth.
 * Deliberately has no interceptors registered, so it structurally cannot
 * attach a stale Authorization header to these calls.
 */
export const tokenClient = axios.create({
  baseURL: BASE_NEW_API_URL,
});
